export default class EloquaServiceUtils {
  #httpClient;

  constructor(httpClient) {
    this.#httpClient = httpClient;
  }

  async sendAppointmentForm({
    visitReasonMnemonic,
    epicDepartmentId,
    slot,
    epicVisitTypeId,
    patientDemographics,
    preferredContactMethod,
    visitDetails,
    insurance,
    referralRequirement,
    hgcrmAgency,
    hgcrmChannel,
    hgcrmCampaignid,
    hgcrmPromotedFacility,
    keyword,
    matchtype,
    placement,
    target,
    hgcrmPromotedServiceline,
    utmMedium,
    utmSource,
    utmContent,
    hgcrmTacticid,
    utmTerm,
    hgcrmTrackingsetid,
    gaCid,
    hgcrmSource,
    utmCampaign,
    hgcrmCampaignUrl,
  }) {
    const slotJsDate = new Date(slot);
    const slotDateTimeParts = slotJsDate.toISOString().split('T');
    const slotDay = slotDateTimeParts[0];
    const slotTime = slotDateTimeParts[1];

    let dobMonth;
    let dobDay;
    let dobYear;
    if (patientDemographics?.dateOfBirth) {
      const dateOfBirthJsDate = new Date(patientDemographics.dateOfBirth);
      dobMonth = dateOfBirthJsDate.getMonth() + 1;
      dobDay = dateOfBirthJsDate.getDate();
      dobYear = dateOfBirthJsDate.getFullYear();
    }

    const body = {
      condition: visitReasonMnemonic,
      location: epicDepartmentId,
      day: slotDay,
      time: slotTime,
      'visit-type': epicVisitTypeId,
      first_name: patientDemographics?.firstName,
      last_name: patientDemographics?.lastName,
      'preferred-name': patientDemographics?.preferredName,
      dob_month: dobMonth,
      dob_day: dobDay,
      dob_year: dobYear,
      gender: patientDemographics?.sex,
      'additional-gender-info': patientDemographics?.genderInformation,
      street_address_1: patientDemographics?.address?.streetAddressLine1,
      street_address_2: patientDemographics?.address?.streetAddressLine2 ?? '',
      city: patientDemographics?.address?.city,
      state_province: patientDemographics?.address?.state,
      postal_code: patientDemographics?.address?.zipCode,
      email_address: patientDemographics?.email,
      home_phone: patientDemographics?.phone?.phoneNumber,
      'phone-type': patientDemographics?.phone?.phoneType,
      'contact-method': preferredContactMethod,
      'additional-details': visitDetails,
      insurance: insurance?.insuranceName,
      'member-id': insurance?.memberNumber,
      'group-number': insurance?.groupNumber,
      'referral-need': referralRequirement,
      hgcrm_agency: hgcrmAgency,
      hgcrm_channel: hgcrmChannel,
      hgcrm_campaignid: hgcrmCampaignid,
      hgcrm_promoted_facility: hgcrmPromotedFacility,
      keyword,
      matchtype,
      placement,
      target,
      hgcrm_promoted_serviceline: hgcrmPromotedServiceline,
      utm_medium: utmMedium,
      utm_source: utmSource,
      utm_content: utmContent,
      hgcrm_tacticid: hgcrmTacticid,
      utm_term: utmTerm,
      hgcrm_trackingsetid: hgcrmTrackingsetid,
      ga_cid: gaCid,
      hgcrm_source: hgcrmSource,
      utm_campaign: utmCampaign,
      hgcrm_campaign_url: hgcrmCampaignUrl,
    };

    const options = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body,
    };

    await this.#httpClient.postFormData(options);
  }
}
